module.exports = __webpack_public_path__ + "media/banners/knowledge-46c10309.png";